/**
 * Created by Slava on 27.06.2024.
 */

Products.initialize = cleverapps.extendFunc(Products.initialize, function () {
    this._super();

    Products.starterPack0.reward = RewardsConfig.Packs[0];
    Products.starterPack.reward = RewardsConfig.Packs[1];
    Products.starterPack2.reward = RewardsConfig.Packs[2];

    Products.noAds.icon = "noads";

    // a kit restored without its offer context pays what the revive sold: the continue's price in hard plus the
    // contents, instead of the framework's flat kit hard. Kings Cup and Lightning Rush keep their own rewards on
    // the context path; only this context-less fallback is shared
    if (cleverapps.config.features.includes("revive_offer")) {
        Object.keys(RewardsConfig.ReviveKits).forEach((kit) => {
            if (Products[kit]) {
                Products[kit].restoreReward = RewardsConfig.ReviveRestoreReward(kit);
            }
        });
    }
});